import { Link } from 'react-router-dom'
import { CONSENT_REOPEN_EVENT, getMeasurementId } from '@/lib/analytics/consent'
import { SUPPORT_EMAIL, SUPPORT_MAILTO, companyCopyright } from '@/lib/company'
import styles from './AppFooter.module.css'

type FooterColumn = { heading: string; links: { label: string; to: string }[] }

// Product / For players / Company columns (site-relaunch Wave 1, T1 §footer).
// The footer is the one place both audiences cross — B2B and player worlds each
// see all columns (the asymmetric cross-link bridge). Demo-club link stays
// in-content on the pages, never here.
const COLUMNS: FooterColumn[] = [
  {
    heading: 'Product',
    links: [
      { label: 'Product', to: '/for-clubs' },
      { label: 'Solutions', to: '/solutions' },
      { label: 'Pricing', to: '/pricing' },
      { label: 'Guides', to: '/guides' },
    ],
  },
  {
    heading: 'For players',
    links: [
      { label: 'For players', to: '/play' },
      { label: 'Clubs', to: '/clubs' },
      { label: 'Tournaments', to: '/tournaments' },
      { label: 'Ladders', to: '/ladders' },
      { label: 'Players', to: '/players' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About us', to: '/about' },
      { label: 'Help', to: '/help' },
      { label: 'Privacy', to: '/privacy' },
      { label: 'Terms', to: '/terms' },
    ],
  },
]

/** The MARKETING site's footer: three link columns over the brand / legal /
 *  contact / consent bottom bar. The columns are what makes it the marketing
 *  site's and nothing else's — a player surface and the workspace draw
 *  WorkspaceFooter, which shares this module's bottom bar and none of the
 *  selling above it.
 *
 *  The entity and the address come from `@/lib/company`, not from here, because
 *  that other footer prints the same two lines. */
export function AppFooter() {
  const analyticsConfigured = Boolean(getMeasurementId())
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <nav className={styles.columns} aria-label="Footer">
          {COLUMNS.map((column) => (
            <div key={column.heading} className={styles.column}>
              <span className={styles.columnHead}>{column.heading}</span>
              {column.links.map((link) => (
                <Link key={link.to} to={link.to} className={styles.columnLink}>
                  {link.label}
                </Link>
              ))}
            </div>
          ))}
        </nav>

        <div className={styles.bottomBar}>
          <div className={styles.brand}>
            <Link to="/" className={styles.wordmark}>
              The Racket Center
            </Link>
            <span className={styles.copy}>{companyCopyright()}</span>
          </div>
          <div className={styles.bottomLinks}>
            <a className={styles.contact} href={SUPPORT_MAILTO}>
              {SUPPORT_EMAIL}
            </a>
            {analyticsConfigured ? (
              <button
                type="button"
                className={styles.linkButton}
                onClick={() => window.dispatchEvent(new Event(CONSENT_REOPEN_EVENT))}
              >
                Cookie settings
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </footer>
  )
}
